import { useQuery } from "react-query";
import { fetchArchivedTeachers } from "api/services/teachers";
import { ETeachersQueryKeys } from "api/endpoints/teachers";
import { logError } from "utils/notifications";
import { TTeachersResponse } from "types/api/teacher";
import { TApiError } from "types/api/error";

type TArchivedTeachersOptions = {
  searchText?: string;
  pageNumber?: number;
  pageSize?: number;
  blocked?: boolean;
};

export const useArchivedTeachers = (options?: TArchivedTeachersOptions) => {
  const {
    searchText = "",
    pageNumber = 0,
    pageSize = 10,
    blocked = false,
  } = options || {};
  return useQuery<TTeachersResponse, TApiError>(
    [
      ETeachersQueryKeys.getArchivedTeachers,
      searchText,
      pageNumber,
      pageSize,
      blocked,
    ],
    () => fetchArchivedTeachers(searchText, pageNumber, pageSize),
    {
      onError: (error) => logError({ error }),
      retry: false,
      enabled: !blocked,
    }
  );
};
